import { render } from "./changeUser.vue?vue&type=template&id=5b88247e&scoped=true"
import script from "./changeUser.vue?vue&type=script&lang=js"
export * from "./changeUser.vue?vue&type=script&lang=js"

import "./changeUser.vue?vue&type=style&index=0&id=5b88247e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b88247e"]])

export default __exports__